import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import {OEObjectModelValueTypes, OEObjectModelValueEditDecls} from './oe-object-model-value-edit-model';
import OEObjectModelValueCellFactory from './oe-object-model-value-cell-factory';

export default class OEObjectModelValueEdit extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            items: this.createItems()
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onValueCellChange = this.onValueCellChange.bind(this);
    }

    createItem(key, modelItem, props, modelItemModifier)   {
        props = props || this.props;

        //
        let subItemModifiers;

        if(modelItemModifier)   {
            const {subItems, ...rest} = modelItemModifier;
            modelItem = Object.assign({}, modelItem, rest);
            subItemModifiers = subItems;
        }

        //
        let localize = this.oe && this.oe.isReady();

        let ret = {
            name:                   key,
            className:              modelItem.className,
            type:                   modelItem.type,
            editType:               modelItem.editType,
            label:                  localize && modelItem.labelId ? this.oe.sharedInterface.getLocalizedStringEnc(modelItem.labelId) : (modelItem.label || key),
            showType:               modelItem.showType,
            disabled:               typeof(modelItem.disabled) === 'boolean' ? modelItem.disabled : false,
            allowUndefined:         modelItem.allowUndefined,
            deferMinMaxConstraint:  modelItem.deferMinMaxConstraint,
            allowPartialUndefined:  modelItem.allowPartialUndefined,
            undefinedEditable:      modelItem.undefinedEditable,
            min:                    modelItem.min,
            max:                    modelItem.max,
            step:                   modelItem.step,
            entries:                modelItem.entries,
            defaultDropdownTitle:   modelItem.defaultDropdownTitle,
            styleOptions:           clone(modelItem.styleOptions),
            collapsed:              modelItem.collapsed,
            value:                  props.object[key]
        };

        //
        if(modelItem.type == OEObjectModelValueTypes.group && modelItem.subItems)  {
            let subItems = [];

            for(let subKey in modelItem.subItems)   {
                let modelSubItem = modelItem.subItems[subKey];
                let modelSubItemModifier = subItemModifiers ? subItemModifiers[subKey] : undefined;

                let subItem = this.createItem(subKey, modelSubItem, props, modelSubItemModifier);
                subItems.push(subItem);
            }

            ret.subItems = subItems;
        }

        return ret;
    }

    createItems(props)    {
        props = props || this.props;

        if(!props.model || !props.object) return [];

        let ret = [];

        for(let key in props.model)   {
            let modelItem = props.model[key];
            let modelItemModifier = props.modelModifier ? props.modelModifier[key] : undefined;

            let item = this.createItem(key, modelItem, props, modelItemModifier);
            ret.push(item);
        }

        return ret;
    }

    componentWillReceiveProps(nextProps)    {
        if(!OEToolbox.shallowEqual(nextProps.object, this.props.object) || !OEToolbox.shallowEqual(nextProps.model, this.props.model) || !OEToolbox.shallowEqual(nextProps.modelModifier, this.props.modelModifier))    {
            this.setState({items: this.createItems(nextProps)});
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);	
    }

    updateLanguage()   {
        this.createItems();
    }

    updateState(released)   {
        if(!this.oe || !this.oe.isReady() || released)   {
            return;
        }

        this.updateLanguage();
    }

    render() {
        let cells = this.state.items.map((item, index) => {
            const className = this.props.cellClassName + (item.className ? ' ' + item.className : '') + (index == 0 ? ' first' : '') + (index == this.state.items.length - 1 ? ' last' : '');
            const disabled = this.props.disabled || !!item.disabled;

            return (
                <OEObjectModelValueCellFactory
                    key={index}
                    {...item}
                    className={className}
                    cellClassName={this.props.cellClassName}
                    disabled={disabled}
                    onChange={this.onValueCellChange}
                />
            );
        });
        
        return  (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div className={'object-model-value-edit ' + this.props.className}>
                    <div className="content">
                        {cells}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    onValueCellChange(sender, name, value)  {
        let object = clone(this.props.object);
        object[name] = value;
        if(!this.props.onChange || OEToolbox.shallowEqual(object, this.props.object))   return;
        this.props.onChange(this, object);
    }
};

OEObjectModelValueEdit.defaultProps = {
    className:                  '',
    cellClassName:              '',
    disabled:                   false,
    model:                      {},
    object:                     {}
};

OEObjectModelValueEdit.propTypes = {
    moduleId:                   PropTypes.string,
    className:                  PropTypes.string,
    cellClassName:              PropTypes.string,
    disabled:                   PropTypes.bool,
    model:                      OEObjectModelValueEditDecls.model,
    modelModifier:              OEObjectModelValueEditDecls.model,
    object:                     PropTypes.object,
    onChange:                   PropTypes.func
};